import SimpleCard from "lib/components/common/simple-card";
import DashboardLayout from "lib/components/layouts/dashboard";
import { PAGE_ROUTES } from "lib/constants/page-routes";
import { AppContext } from "lib/contexts/app-context";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import usePatients from "lib/hooks/usePatients";
import { Button } from "react-bootstrap";
import FlexBox from "lib/components/common/flex-box";
import usePatientBookings from "lib/hooks/usePatientBookings";
import ErrorBox from "lib/components/common/error-box";

const breadcrumbItems = [
  {
    label: "Dashboard",
    path: PAGE_ROUTES.PATIENT.Dashboard,
  },
  {
    label: "Consent Forms",
    path: ''
  },
] as BreadcrumbItem[];

const PatientConsentFormPage = () => {
    const navigateTo = useNavigate();
    const { appState } = useContext(AppContext);
    const patientId = appState?.user_id;
    
    const {
        error,
        loading,
    } = usePatientBookings();
    const { fetchConsentForm, revokeConsentForm, loading: patientsLoading } = usePatients();
    const [consentForms, setConsentForms] = useState<any[]>([]);

  useEffect(() => {
    if (!patientId) return;

    fetchConsentForm(patientId, (response) => {
      setConsentForms(Array.isArray(response) ? response : []); 
    });
  }, [patientId]);

  const handleAirPod = () => {
    navigateTo(PAGE_ROUTES.PATIENT.AirpodForm, {state: {patientId: patientId}});
  }

  const handleCryoChamber = () => {
    navigateTo(PAGE_ROUTES.PATIENT.CryoChamberForm, {state: {patientId: patientId}});
  }

  const handleInfrared = () => {
    navigateTo(PAGE_ROUTES.PATIENT.infraredConsentForm, {state: {patientId: patientId}});
  }

  const getFormByType = (type: string) => {
    return consentForms.find((item) => item.parentType === type);
  };

  const handleView = (url: string) => {
    window.open(url, "_blank");
  };

  const handleRevoke = (id: string) => {
    if (window.confirm("Are you sure you want to revoke this consent form?")) {
      revokeConsentForm(patientId, id, () => {
        fetchConsentForm(patientId, (response) => {
          setConsentForms(Array.isArray(response) ? response : []); 
        });
      });
    }
    // Call API here to revoke -> then refresh fetchConsentForm()
  };

  // Show loading state while initializing
  if (loading) {
    return (
      <div className="text-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-2">Loading booking options...</p>
      </div>
    );
  }

  if (error) return <ErrorBox message={error} />;

  return (
    <DashboardLayout breadcrumbItems={breadcrumbItems}>
        <SimpleCard
            title="Consent Forms"
            className="shadow-sm"
            >
        <FlexBox
            direction="row"
            gap="3"
            justifyContent="left"
            className="flex-wrap justify-content-center justify-content-lg-start"
        >
            
            <SimpleCard className="membership-package-card mb-0 mb-md-3">
                <FlexBox
                direction="column"
                alignItems="center"
                justifyContent="between"
                className="h-100 p-0 p-md-4"
                >
                <div className="w-100 text-center">
                    <h5 className="fw-bold text-primary">Infrared Souna</h5>
                </div>
                <FlexBox gap="2">
                    {getFormByType("infrared-form") ? (
                    <>
                        <Button className="btn-info text-white"
                        onClick={() => handleView(getFormByType("infrared-form").url)}>
                        View
                        </Button>
                        <Button className="btn-danger text-white"
                        onClick={() => handleRevoke(getFormByType("infrared-form").id)}>
                        Revoke
                        </Button>
                    </>
                    ) : (
                    <Button onClick={handleInfrared}>
                        Sign Consent Form
                    </Button>
                    )}
                </FlexBox>
                </FlexBox>
            </SimpleCard>

            <SimpleCard className="membership-package-card mb-0 mb-md-3">
                <FlexBox
                direction="column"
                alignItems="center"
                justifyContent="between"
                className="h-100 p-0 p-md-4"
                >
                <div className="w-100 text-center">
                    <h5 className="fw-bold text-primary">CryoChamber</h5>
                </div>
                <FlexBox gap="2">
                    {getFormByType("cryochamber-form") ? (
                    <>
                        <Button className="btn-info text-white"
                        onClick={() => handleView(getFormByType("cryochamber-form").url)}>
                        View
                        </Button>
                        <Button className="btn-danger text-white"
                        onClick={() => handleRevoke(getFormByType("cryochamber-form").id)}>
                        Revoke
                        </Button>
                    </>
                    ) : (
                    <Button onClick={handleCryoChamber}>
                        Sign Consent Form
                    </Button>
                    )}
                </FlexBox>
                </FlexBox>
            </SimpleCard>

            <SimpleCard className="membership-package-card mb-0 mb-md-3">
                <FlexBox
                direction="column"
                alignItems="center"
                justifyContent="between"
                className="h-100 p-0 p-md-4"
                >
                <div className="w-100 text-center">
                    <h5 className="fw-bold text-primary">AirPod</h5>
                </div>
                <FlexBox gap="2">
                    {getFormByType("airpod-form") ? (
                    <>
                        <Button className="btn-info text-white"
                        onClick={() => handleView(getFormByType("airpod-form").url)}>
                        View
                        </Button>
                        <Button className="btn-danger text-white"
                        onClick={() => handleRevoke(getFormByType("airpod-form").id)}>
                        Revoke
                        </Button>
                    </>
                    ) : (
                    <Button onClick={handleAirPod}>
                        Sign Consent Form
                    </Button>
                    )}
                </FlexBox>
                </FlexBox>
            </SimpleCard>
            
        </FlexBox>
        </SimpleCard>
    </DashboardLayout>
  );
};

export default PatientConsentFormPage;